import { useEffect } from "react";
import { Link } from "react-router-dom";
import ClientExperienceShell from "../components/ClientExperienceShell";
import { bookingBackgroundGifUrl } from "../../../shared/lib/bookingConfig";
import "./styles/ClientLandingPage.css";

function ClientLandingPage() {
  useEffect(() => {
    document.title = "Book Haircut";
  }, []);

  return (
    <ClientExperienceShell backgroundGifUrl={bookingBackgroundGifUrl} className="client-hero-page">
      <div className="minimal-landing-root">
        <div className="minimal-landing-center">
          <Link className="client-cta-link" to="/services">
            Book Now
          </Link>
        </div>
      </div>
    </ClientExperienceShell>
  );
}

export default ClientLandingPage;